import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import './CartModal.css';

const AccountModal = ({ isOpen, onClose }) => {
  const { isAuthenticated, isAdmin, isCoworker, canManageProducts, canManageOrders, logout } = useAuth();
  const { t } = useLanguage();

  if (!isOpen) return null;

  const handleLogout = () => {
    logout();
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-panel modal-panel--account" onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div className="modal-header">
          <h2 className="modal-title">{t('account.myAccount')}</h2>
          <button className="modal-close" onClick={onClose} aria-label={t('common.close')}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2"/>
              <line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </button>
        </div>

        {/* Content */}
        {isAuthenticated ? (
          <>
            <ul className="account-menu">
              {!isCoworker && (
                <>
                  <li className="account-menu__item">
                    <Link to="/user/orders" onClick={onClose}>{t('account.orders')}</Link>
                  </li>
                  <li className="account-menu__item">
                    <Link to="/user/wishlist" onClick={onClose}>{t('account.wishlist')}</Link>
                  </li>
                  <li className="account-menu__item">
                    <Link to="/user/payments" onClick={onClose}>{t('account.paymentMethods')}</Link>
                  </li>
                  <li className="account-menu__item">
                    <Link to="/user/addresses" onClick={onClose}>{t('account.deliveryAddresses')}</Link>
                  </li>
                  <li className="account-menu__item">
                    <Link to="/user/settings" onClick={onClose}>{t('account.settings')}</Link>
                  </li>
                </>
              )}
              {!isCoworker && (isAdmin || canManageProducts || canManageOrders) && (
                <>
                  {isAdmin && (
                    <li className="account-menu__item">
                      <Link to="/admin/dashboard" onClick={onClose}>{t('account.adminDashboard')}</Link>
                    </li>
                  )}
                  {canManageProducts && (
                    <li className="account-menu__item">
                      <Link to="/admin/products" onClick={onClose}>{t('account.manageProducts')}</Link>
                    </li>
                  )}
                  {isAdmin && (
                    <li className="account-menu__item">
                      <Link to="/admin/users" onClick={onClose}>{t('account.users')}</Link>
                    </li>
                  )}
                  {canManageOrders && (
                    <li className="account-menu__item">
                      <Link to="/admin/orders" onClick={onClose}>{t('account.orders')}</Link>
                    </li>
                  )}
                </>
              )}
              {isCoworker && (
                <li className="account-menu__item">
                  <Link to="/admin/orders" onClick={onClose}>Orders workspace</Link>
                </li>
              )}
            </ul>

            <button
              className="btn btn--primary"
              style={{ margin: '16px', width: 'calc(100% - 32px)' }}
              onClick={handleLogout}
            >
              {t('account.signOut')}
            </button>
          </>
        ) : (
          <div className="auth-buttons">
            <Link to="/login" className="btn btn--outline">{t('account.signIn')}</Link>
            <Link to="/register" className="btn btn--secondary">{t('account.signUp')}</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountModal;
